export default {
  ENABLE_SENTRY: true,
};
